module.exports = __webpack_public_path__ + "img/Bookeh.a8588bd4.png";